export enum LabEvents {
  TrackStarted = 'track.started',
  TrackCompleted = 'track.completed',
  ChallengeStarted = 'track.challenge_started',
  ChallengeSkipped = 'track.challenge_skipped',
  ChallengeCompleted = 'track.challenge_completed'
}
